module.exports = __webpack_public_path__ + "static/media/done.33201f04.svg";